(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/views/partials/placeholder.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/views/partials/placeholder.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.emp_video_player=_cmps.emp_video_player||{};
_cmps.emp_video_player.templates=_cmps.emp_video_player.templates||{};
svs.components.emp_video_player.templates.placeholder = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"emp-partial js-emp-placeholder\"></div>\n";
},"useData":true});
Handlebars.partials['components-components-emp_video_player-placeholder'] = svs.components.emp_video_player.templates.placeholder;
})(svs, Handlebars);


 })(window);